module.exports = __webpack_public_path__ + "img/offenlegung-diagramm-v2.d57dd0d0.jpg";